import {
  useModuleBEM,
  IconNameEnum,
  useCfarStyles,
} from "@b2bportal/core-themes";
import { CoreFlightsCfarExerciseComponents } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Icon } from "@tenant/ui";

import { AirCfarExerciseGenericActionView } from "../AirCfarExerciseGenericActionView";

import defaultStyles from "./AirCfarExerciseErrorVoid.module.scss";

export interface AirCfarExerciseErrorVoidProps {
  termsAndConditionsLink: string;
  onContinueClick: () => void;
  onGoBackClick: () => void;
}

export const AirCfarExerciseErrorVoid = (
  props: AirCfarExerciseErrorVoidProps
) => {
  const [block, cn] = useModuleBEM(
    useCfarStyles(
      CoreFlightsCfarExerciseComponents.AirCfarExerciseErrorVoid,
      defaultStyles
    ),
    CoreFlightsCfarExerciseComponents.AirCfarExerciseErrorVoid
  );
  const { t } = useI18nContext();

  const { termsAndConditionsLink, onContinueClick, onGoBackClick } = props;

  return (
    <div className={block}>
      <AirCfarExerciseGenericActionView
        title={t("core-flights-cfar.exercise.void.title")}
        description={
          <div>
            <div className={cn("description")}>
              {t("core-flights-cfar.exercise.void.description")}
            </div>
            <div className={cn("terms-and-conditions")}>
              <a href={termsAndConditionsLink} target="_blank" rel="noreferrer">
                {t("core-flights-cfar.exercise.void.termsAndConditions")}
              </a>
            </div>
          </div>
        }
        headerIcon={<Icon iconName={IconNameEnum.airplane} />}
        footerButtons={[
          <button className={cn("continue-button")} onClick={onContinueClick}>
            {t("core-flights-cfar.exercise.void.continue")}
          </button>,
          <button className={cn("go-back-button")} onClick={onGoBackClick}>
            {t("core-flights-cfar.exercise.void.goBack")}
          </button>,
        ]}
      />
    </div>
  );
};
